import { SelectList, ListItem, Button, Icons } from 'construct-ui';

/**
 * @deprecated
 * 
 * Instead, please use
 * ```
 * src\app\components\single-select\single-select.component.js
 * ```
 */
export default function SingleSelectCommonComponentView() {
  let selectedItem = { code: "", name: "" };
  let iconList = [];
  let handleSelect = (item) => { }

  function renderItem(item) {
    if (iconList.length > 0) {
      let icon = "";
      let text = "";
      let color = "";
      let textIcon = "";
      let iconArr = iconList.filter(x => x.code == item.code);
      if (iconArr.length == 1) {
        icon = iconArr[0].icon;
        text = iconArr[0].text;
        color = iconArr[0].color;
        textIcon = iconArr[0].textIcon;
      }

      return m(ListItem, {
        contentLeft: icon != "" ? m('i.bi', { "class": icon }) : textIcon == "" ? m('.badge.colorRound', { "style": "font-size:13px;background-color:" + color }, text) : m('.badge.colorRound', { "style": "background-color:" + color }, m('span', m('i.bi', { "class": textIcon, "style": "margin-right:0" }), text)),// m('i.bi', { "class": icon }),
        label: item.name,
        selected: selectedItem.code == item.code,
      })
    } else {
      return m(ListItem, {
        label: item.name,
        selected: selectedItem.code == item.code,
      })
    }
  }

  function itemPredicate(query, item) {
    var xxx = item.name.toLowerCase().includes(query.toLowerCase());
    return xxx;
  }

  function handleSelectedItem(item) {
    selectedItem.code = item.code;
    selectedItem.name = item.name;
    handleSelect(selectedItem);
  }

  function renderLabel() {
    if (selectedItem.name && selectedItem.name != "") {
      return selectedItem.name;
    }
    else {
      return 'Choose...';
    }
  }

  return {
    oninit: ({ attrs }) => {
      if (attrs.handleSelect) {
        handleSelect = attrs.handleSelect;
      }
    },
    view: ({ attrs }) => {
      selectedItem.code = attrs.selectedItem?.code;
      selectedItem.name = attrs.selectedItem?.name;
      iconList = attrs.iconList;
      
      return m(SelectList, {
        closeOnSelect: true,
        items: attrs.items,
        itemRender: renderItem,
        itemPredicate: itemPredicate,
        onSelect: handleSelectedItem,
        popoverAttrs: {
          hasArrow: false
        },
        trigger: m(Button, {
          align: 'left',
          disabled: attrs.disabled,
          compact: true,
          class: 'select-list',
          fluid: true,
          iconRight: Icons.CHEVRON_DOWN,
          outlined: true,
          label: renderLabel(),
        })
      })
    }
  };
}
